import React, { useState } from 'react';
import './Dashboard.css';

function Dashboard() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (
      email === 'attorney@edgarlopezlaw.com' &&
      password === 'odoo_contracts'
    ) {
      window.location.href = 'https://edgarlopezlaw.odoo.com/odoo';
      return;
    }

    setError('Invalid email or password.');
  };

  return (
    <div className="dashboard-container">
      <div className="login-container">
        <img
          src="/seal.png"
          alt="Edgar Lopez Law"
          className="seal"
        />

        <h1 className="dashboard-title">Edgar Lopez Law</h1>
        <h2 className="dashboard-subtitle">
          Client & Staff Secure Portal
        </h2>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">
              Password
            </label>
            <input
              type="password"
              id="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && (
            <div className="login-error" role="alert">
              {error}
            </div>
          )}

          <button type="submit" className="login-button">
            Sign In
          </button>
        </form>

        <div className="forgot-password">
          <a href="/forgot-password">
            Forgot your password?
          </a>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;